// IM 会话
import { USER_PLATFORM_SOURCE, CONVERSATION_STATUS, USER_ROLE } from '@/constant'
import { getImInputContentByCache } from '../plugins/storage'
import { isNil } from 'lodash'
import { i18n } from '@/i18n/index.js'

export default class ConversationModel {
  // {
  //     "conversationId":"20907678",
  //     "userId":"965006065497076612",
  //     "serviceUserId":"1021974",
  //     "serviceUserNO":"A1021974",
  //     "serviceUserName":"王禹",
  //     "name":"测试*****",
  //     "role":1,
  //     "enterpriseRole":null,
  //     "avatar":"https://dev-image56-conf-oss.ymm56.com/ymmfile/user-pub/bdf40a6c-7728-4957-9dc3-63d04367a19e?Expires=1634183364&amp;OSSAccessKeyId=LTAIq0WRi8jPwg5y&amp;Signature=KEg89BNrI4p7bR4KZ%2BYMn6nXp0c%3D",
  //     "userTag":null,
  //     "lastImMessageDTO":[MessageModel],
  //     "unReadMsgNum":0,
  //     "unReplyTime":null,
  //     "unReplyMsgTime":2685,
  //     "beginConversationTime":1634181650000,
  //     "telephone":"13001021974",
  //     "status":2,
  //     "endConversationTime":null,
  //     "imMessageStartId":"1000000000000003144",
  //     "imMessageEndId":"1000000000000003170",
  //     "inviteCommentsStatus":null,
  //     "source":1,
  //     "evaluateTime":null,
  //     "evaluateResult":-1,
  //     "serviceTicketStatus":-1,
  //     "updateTime":1634182775870,
  //     "workbenchId":1,
  //     "workbenchName":null,
  //     "isTransfer":false,
  //     "transferRemark":null,
  //     "inviteCommentType":null,
  //     "conversationType":0,
  //     "lastCustomerSendTime":1634181650000,
  //     "sourceWorkbenchId":null,
  //     "sourceWorkbenchDesc":null,
  //     "userTagList":[
  //         {
  //             "code":10002,
  //             "tag":"城市先锋",
  //             "type":"growthLevel"
  //         }
  //     ],
  //     "platform":1,
  //     "originNumber":"999130649254871974",
  //     "draftContent":"121212",
  //     "base64Avatar":"data:image/png;base64,iVBORw0K... (10025 total length)",
  //     "_firstInAndUnActive":false
  // }
  constructor({ conversationId, userTagList, ...baseInfo }) {
    this.conversationId = conversationId
    this.status = baseInfo?.status
    this.baseInfo = baseInfo
    this.userTagList = userTagList || []
  }

  // 正在会话中
  isConversation(status) {
    if (!isNil(status)) return status === CONVERSATION_STATUS.ON_GOING
    return this.baseInfo.status === CONVERSATION_STATUS.ON_GOING
  }
  // 是否VIP
  isVip() {
    if (!Array.isArray(this.userTagList)) return false
    // 目前只有司机vip，以后可能拓展为货主vip
    return !!this.userTagList.find(tag => tag.type === 'vipDriver')
  }
  // // 是否有高信用等级直连人工权益，用于展示信用优秀
  isGoodCredit() {
    return this.baseInfo.hasHighCreditEquity
  }
  // 是否为五星货主
  isFiveStarShipper() {
    return this.baseInfo.hasFiveStarShipperEquity
  }
  // 用户成长等级标签
  getGrowthLevelTag() {
    if (!Array.isArray(this.userTagList)) return ''
    const userTag = this.userTagList.find(tag => tag.type === 'growthLevel')
    return userTag ? userTag.tag.slice(0, 4) : ''
  }
  // 尊享会员
  isEnjoyVip() {
    if (!Array.isArray(this.userTagList)) return ''
    // mock
    // this.userTagList = [
    //   {
    //     "code": 10002,
    //     "tag": "城市先锋",
    //     "type": "growthLevel"
    //   },
    //   {
    //     "code": 99999,
    //     "tag": "尊享会员",
    //     "type": "V6shipper"
    //   }
    // ]
    const userTag = this.userTagList.find(tag => tag.type === 'V6shipper')
    return userTag ? userTag.tag.slice(0, 4) : ''
  }
  handleHTMLDecode(text) {
    let temp = document.createElement('div')
    temp.innerHTML = text
    const output = temp.innerText || temp.textContent
    temp = null
    return output
  }
  /**
   * 获取草稿展示文本
   * @param content {array} htmlStr处理得到的输入内容
   * @param isDecode {Boolean} 是否需要解析文本处理
   * @returns {*}
   */
  getDraftContent(content, isDecode = true) {
    try {
      if (!content) content = getImInputContentByCache(this.conversationId) || ''
      // 旧的设计content是数组使用filter处理，为了保证兼容性，保留数组数据结构
      if (Array.isArray(content)) content = content[0] || ''
      if (!isDecode) return content
      const hasImg = this.matchFirstImgTag('' + content)
      const text = this.handleHTMLDecode(content)
      return text?.length ? text : hasImg ? '[图片]' : ''
    } catch (e) {
      console.log(e)
      return null
    }
  }

  matchFirstImgTag(htmlStr) {
    const reg = /<img.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/i //匹配img标签的正则表达式
    return htmlStr.match(reg)
  }

  // 获取角色
  getRoleTag() {
    if (this.baseInfo.role === 'driver') return i18n.t('crm.onlineCs.user.driver')
    if (this.baseInfo.role === 'shipper') return i18n.t('crm.onlineCs.user.shipper')
    return i18n.t('crm.onlineCs.status.unknown')
  }

  getRole() {
    return this.baseInfo.role
  }
}
